"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserContextProvider = exports.UserContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var defaults_1 = require("./defaults");
var states_1 = require("./states");
var useLocalStorage_1 = require("../hooks/useLocalStorage");
var index_1 = require("./index");
var auth_1 = require("./../../services/auth");
var profile_1 = require("../../services/profile");
exports.UserContext = (0, react_1.createContext)({
    user: defaults_1.defaultConfig.user,
    socialAuthorize: defaults_1.defaultConfig.socialAuthorize,
    changePassword: defaults_1.defaultConfig.changePassword,
    login: defaults_1.defaultConfig.login,
    logout: defaults_1.defaultConfig.logout,
    forgot: defaults_1.defaultConfig.forgot,
    reset: defaults_1.defaultConfig.reset,
    fetchProfile: defaults_1.defaultConfig.fetchProfile,
    updateProfile: defaults_1.defaultConfig.updateProfile,
    updateAvatar: defaults_1.defaultConfig.updateAvatar,
    getRefreshedToken: defaults_1.defaultConfig.getRefreshedToken,
    emailVerify: defaults_1.defaultConfig.emailVerify,
    register: defaults_1.defaultConfig.register,
    token: null,
    tokenExpireDate: null,
});
var UserContextProvider = function (_a) {
    var children = _a.children, defaults = _a.defaults, apiUrl = _a.apiUrl;
    var abortControllers = (0, react_1.useRef)({});
    (0, react_1.useEffect)(function () {
        var _a;
        if (defaults) {
            defaults.user !== null &&
                setUser({
                    loading: false,
                    value: (_a = defaults.user) === null || _a === void 0 ? void 0 : _a.value,
                    error: undefined,
                });
        }
    }, [defaults]);
    var _b = (0, useLocalStorage_1.useLocalStorage)("user", "token", null), token = _b[0], setToken = _b[1];
    var _c = (0, useLocalStorage_1.useLocalStorage)("user", "user", (0, index_1.getDefaultData)("user", __assign(__assign({}, defaults_1.defaultConfig), defaults))), user = _c[0], setUser = _c[1];
    var logout = (0, react_1.useCallback)(function () {
        // API Call here to destroy token
        resetState();
        return Promise.resolve();
    }, []);
    (0, react_1.useEffect)(function () {
        fetchProfile().catch(function () {
            logout();
        });
    }, [token, logout]);
    (0, react_1.useEffect)(function () {
        if (token) {
            setUser(function (prevState) { return (__assign(__assign({}, prevState), { loading: true, error: undefined })); });
            auth_1.profile
                .bind(null, apiUrl)(token)
                .then(function (response) {
                if (response.success) {
                    setUser({
                        loading: false,
                        value: response.data,
                    });
                }
                if (response.success === false) {
                    setUser(function (prevState) { return (__assign(__assign({}, prevState), { loading: false, error: response })); });
                }
            })
                .catch(function () {
                logout();
            });
        }
    }, [token, logout]);
    var login = (0, react_1.useCallback)(function (body) {
        return auth_1.login
            .bind(null, apiUrl)(body)
            .then(function (response) {
            if (response.success) {
                setToken(response.data.token);
                //setTokenExpireDate(response.data.expires_at);
            }
            else {
                setUser(function (prevState) {
                    return prevState
                        ? __assign(__assign({}, prevState), { error: response, loading: false }) : { error: response, loading: false };
                });
            }
        })
            .catch(function (error) {
            setUser(function (prevState) {
                return prevState
                    ? __assign(__assign({}, prevState), { error: error, loading: false }) : { error: error, loading: false };
            });
        });
    }, []);
    var fetchProfile = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "profile",
                mode: "value",
                fetchAction: auth_1.profile.bind(null, apiUrl)(token, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setUser,
            })
            : Promise.reject("noToken");
    }, [token]);
    var updateProfile = (0, react_1.useCallback)(function (body) {
        setUser(function (prevState) { return (__assign(__assign({}, prevState), { loading: true })); });
        return token
            ? auth_1.updateProfile
                .bind(null, apiUrl)(body, token)
                .then(function (res) {
                if (res.success === true) {
                    setUser(function (prevState) { return ({
                        value: __assign({}, res.data),
                        loading: false,
                    }); });
                }
                else if (res.success === false) {
                    setUser(function (prevState) { return (__assign(__assign({}, prevState), { error: res, loading: false })); });
                }
            })
            : Promise.reject("noToken");
    }, [token]);
    var updateAvatar = (0, react_1.useCallback)(function (file) {
        setUser(function (prevState) {
            return __assign(__assign({}, prevState), { loading: true });
        });
        return token
            ? auth_1.updateAvatar
                .bind(null, apiUrl)(file, token)
                .then(function (res) {
                if (res.success === true) {
                    setUser(function (prevState) { return (__assign(__assign({}, prevState), { value: __assign(__assign({}, res.data), { avatar: res.data.avatar, path_avatar: res.data.path_avatar }), loading: false })); });
                }
            })
            : Promise.reject("noToken");
    }, [token]);
    var getRefreshedToken = (0, react_1.useCallback)(function () {
        return token
            ? auth_1.refreshToken
                .bind(null, apiUrl)(token)
                .then(function (res) {
                if (res.success) {
                    setToken(res.data.token);
                }
            })
                .catch(function (error) {
                console.log(error);
            })
            : Promise.reject("noToken");
    }, [token]);
    var changePassword = (0, react_1.useCallback)(function (body) {
        return token
            ? profile_1.changePassword.bind(null, apiUrl)(token, body)
            : Promise.reject("noToken");
    }, [token]);
    var socialAuthorize = (0, react_1.useCallback)(function (token) {
        setToken(token);
    }, []);
    var tokenExpireDate = (0, react_1.useMemo)(function () {
        try {
            return token
                ? new Date(JSON.parse(atob(token.split(".")[1])).exp * 1000).toISOString()
                : null;
        }
        catch (er) {
            return null;
        }
    }, [token]);
    (0, react_1.useEffect)(function () {
        if (tokenExpireDate) {
            var ms = Math.max(1000, new Date(tokenExpireDate).getTime() - Date.now() - 5000); // 5 seconds grace period
            var t_1 = setTimeout(function () { return getRefreshedToken(); }, ms);
            return function () {
                clearTimeout(t_1);
            };
        }
    }, [tokenExpireDate]);
    var resetState = (0, react_1.useCallback)(function () {
        // TODO pass reset State to User
        setToken(null);
        setUser(defaults_1.defaultConfig.user);
    }, []);
    var register = (0, react_1.useCallback)(function (body) {
        return auth_1.register.bind(null, apiUrl)(body);
    }, []);
    return ((0, jsx_runtime_1.jsx)(exports.UserContext.Provider, __assign({ value: {
            tokenExpireDate: tokenExpireDate,
            token: token,
            user: user,
            socialAuthorize: socialAuthorize,
            changePassword: changePassword,
            login: login,
            logout: logout,
            forgot: auth_1.forgot.bind(null, apiUrl),
            reset: auth_1.reset.bind(null, apiUrl),
            fetchProfile: fetchProfile,
            updateProfile: updateProfile,
            updateAvatar: updateAvatar,
            getRefreshedToken: getRefreshedToken,
            emailVerify: auth_1.emailVerify.bind(null, apiUrl),
            register: register,
        } }, { children: children })));
};
exports.UserContextProvider = UserContextProvider;
